import { useState } from "react";
import { cases } from "@/mocks/heiliao";

const filters = ["全部", "实锤", "存疑", "反转", "进展", "辟谣"];

const statusStyle: Record<string, string> = {
  实锤: "bg-primary-100 text-primary-700",
  存疑: "bg-accent-100 text-accent-900",
  反转: "bg-secondary-200 text-secondary-900",
  进展: "bg-secondary-100 text-secondary-800",
  辟谣: "bg-background-200 text-foreground-700",
};

const evdIcon: Record<string, string> = {
  截图: "ri-image-2-line",
  录音: "ri-mic-line",
  视频: "ri-video-line",
  原帖: "ri-file-text-line",
  转账: "ri-bank-line",
  公告: "ri-megaphone-line",
};

export default function EvidenceList() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? cases : cases.filter((c) => c.status === active || (active === "进展" && c.status === "进展"));

  return (
    <section id="latest" className="scroll-mt-20 bg-background-50 py-10 md:py-16">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="mb-6 flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div>
            <div className="mb-1 flex items-center gap-2 text-xs font-bold tracking-widest text-primary-600">
              <i className="ri-shield-check-fill text-sm"></i>最新实锤档案
            </div>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              已经对上号的瓜
            </h2>
            <p className="mt-2 max-w-lg text-sm text-foreground-500">
              每条都标注了当前状态与已有的证据类型，帮你先分清「证了」还是「只是有人说」。
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {filters.map((f) => (
              <button
                key={f}
                onClick={() => setActive(f)}
                className={
                  "whitespace-nowrap rounded-full px-3 py-1 text-sm transition-colors " +
                  (active === f
                    ? "bg-primary-500 font-bold text-background-50"
                    : "bg-secondary-100 text-secondary-800 hover:bg-secondary-200")
                }
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {list.map((c) => (
            <a
              key={c.title}
              href="#latest"
              className="group flex flex-col rounded-xl border border-background-200 bg-background-100/70 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-2">
                  <span className={"whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-bold " + statusStyle[c.status]}>
                    {c.status}
                  </span>
                  <span className="text-xs text-foreground-400">{c.cat}</span>
                </div>
                <span className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500">
                  <i className="ri-fire-line text-primary-500"></i>{c.heat / 10}° · {c.date}
                </span>
              </div>

              <h3 className="mt-3 font-heading text-lg font-black leading-snug text-foreground-950 group-hover:text-primary-700">
                {c.title}
              </h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{c.summary}</p>

              <div className="mt-4 flex items-center justify-between">
                <div className="flex flex-wrap gap-1.5">
                  {c.tags.map((t) => (
                    <span
                      key={t}
                      className="flex items-center gap-1 whitespace-nowrap rounded-full bg-background-50 px-2 py-0.5 text-xs text-foreground-600"
                    >
                      <i className={(evdIcon[t] ?? "ri-file-line") + " text-primary-500"}></i>
                      {t}
                    </span>
                  ))}
                </div>
                <span className="flex shrink-0 items-center gap-1 whitespace-nowrap text-xs font-bold text-primary-600">
                  看证据链<i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}